import { s } from "../lib/constants";

export default function JoinScreen({ joinCode, setJoinCode, error, onJoin, onBack }) {
  return (
    <div style={s.step}>
      <p style={s.eyebrow}>join session</p>
      <p style={s.display}>Enter the four-digit code</p>
      <p style={s.body}>Your partner started a session and should have a code for you.</p>
      {error && <div style={s.errorBox}>{error}</div>}
      <input
        style={{ ...s.input, fontSize: "2rem", letterSpacing: "0.3em", textAlign: "center" }}
        maxLength={4}
        value={joinCode}
        onChange={e => setJoinCode(e.target.value.replace(/\D/g, ""))}
        placeholder="0000"
      />
      <div style={s.btnRow}>
        <button style={s.btnPrimary} onClick={onJoin} disabled={joinCode.length !== 4}>
          Join
        </button>
        <button style={s.btnGhost} onClick={onBack}>Back</button>
      </div>
    </div>
  );
}
